import Vue from 'vue';
import VueCarousel from '@chenfengyuan/vue-carousel';
import VueMeta from 'vue-meta'
import VueFbCustomerChat from 'vue-fb-customer-chat'

Vue.use(VueMeta)
Vue.component(VueCarousel.name, VueCarousel);
Vue.use(VueFbCustomerChat, {
    page_id: '107495067762338', //  change 'null' to your Facebook Page ID,
    theme_color: '#333333', // theme color in HEX
    locale: 'en_US', // default 'en_US'
})